exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main-content[data-v-b414bf4a]{text-align:left}.job-input-search[data-v-b414bf4a]{width:260px;margin-right:20px}.nomore[data-v-b414bf4a]{padding:30px}", ""]);

// exports
